// Mock data for Brave Me landing page. Verbiage sourced from braveme.com

export const nav = {
  links: [
    { label: "About", href: "#about" },
    { label: "Our Videos", href: "#videos" },
    { label: "Brave Me Kid of the Week", href: "#kid-of-the-week" },
    { label: "Watch Now", href: "#watch" },
  ],
  shop: { href: "#shop", logo: "/cco-word-logo-transparent.png", label: "Courage Canyon Outfitters" },
};

export const hero = {
  eyebrow: "Home",
  title: "Turning Knowledge Into Courage!",
  description:
    "Brave Me is the source you can turn to as you help a child prepare for an upcoming medical procedure or process life with a medical diagnosis \u2013 either theirs or that of a loved one. Help isn\u2019t just \u201con the way,\u201d \u2013 Brave Me is here today to empower patients all over the world!",
  cta: { label: "Learn more about our videos", href: "#videos" },
  image: "/riley-nano.jpg",
};

export const braveryBoost = {
  title: "Bravery Boost Guarantee!",
  body:
    "Every patient who watches a Brave Me video will gain valuable medical knowledge and the strength to be emboldened to face what\u2019s ahead. Empowerment can come from daily interactions in our Courage Canyon Outfitters. Bring Riley with you to a doctor\u2019s appointment, wear a Brave Me shirt and let people know you are stronger and braver than most, get your go-to blanket that will be with you everywhere. Best of all, rock your cape and remind everyone that they are dealing with a Health Hero!",
};

export const empowerWho = {
  title: "Power up the Patients",
  items: [
    {
      id: "child",
      color: "orange",
      image: "/empower/child.jpg",
      title: "Any Child",
      body: "Kids are just like us and want to understand what the road ahead entails. After watching a Brave Me video, kids are empowered exponentially. With our merch, everyone they meet will know they are living a life of true bravery.",
    },
    {
      id: "human",
      color: "red",
      image: "/empower/human.jpg",
      title: "Any Human",
      body: "Do you have a friend, neighbor, coworker, etc. that is struggling with a diagnosis or scared of an MRI? Boost their bravery by telling them about our videos \u2013 or ordering up a fresh way for them to tell the world they are amazing!",
    },
    {
      id: "world",
      color: "blue",
      image: "/empower/world.jpg",
      title: "The World",
      body: "Brave Me wants people all over the world to prepare and understand through our free videos. Anyone with access to YouTube can watch any of our four videos this minute. Anyone struggling with medical care can tune in to Brave Me HQ for a bravery boost.",
    },
  ],
};

export const mission = {
  image: "/riley-nano.jpg",
  imageAlt: "Riley and Nano, Brave Me characters",
  bullets: [
    "Prepare and inform kids through adorable, engaging characters and an inspiring, entertaining story that highlights their strength and resilience.",
    "Treat children with respect \u2013 honestly communicating the physical side of what's happening while emphasizing their emotional health.",
    "Give them answers to their questions, acknowledgement of their fear, and encouragement that they can get through anything.",
    "Empower kids to harness their inner bravery and stay calm by self-soothing and leaning on family and friends.",
    "Turn knowledge into courage \u2013 so kids can be strong, calm and ready for what's going on.",
  ],
  paragraphs: [
    "Brave Me videos prepare and inform kids through adorable and engaging characters and an inspiring and entertaining story that highlight the strength and resilience they possess. Our sole mission is to treat children with respect by honestly communicating the physical aspect of what is happening while emphasizing the crucial importance of their emotional health as well.",
    "Kids are no different than adults\u2026when something medically scary is happening they crave answers to their questions, acknowledgement of their fear and encouragement that they can get through anything. After watching Brave Me videos, kids will be empowered to harness their inner bravery when facing any medical situation. They will be ready and remain calm by self-soothing and leaning on the support of family and friends. They will turn knowledge into courage. Brave Me exists so that kids can be strong, calm and ready for what\u2019s going on.",
  ],
};

export const testimonials = [
  {
    id: 1,
    quote:
      "After watching the Brave Me MRI video, our son Matthew jumped out of bed the morning of his procedure, ready to go. What a relief!",
    author: "Mom Melissa",
    accent: "orange",
  },
  {
    id: 2,
    quote:
      "Riley asked the exact questions I wanted to ask, but didn\u2019t want to. Now I know the answers.",
    author: "Tyler, 9",
    accent: "blue",
  },
];

export const themeSong = {
  title: "Hear the Brave Me Theme Song",
  subtitle: "Sing along and feel the bravery build!",
  audio: "/brave-me-theme.ogg",
  image: "/theme-song-characters.jpg",
};

export const videos = {
  sectionTitle: "Brave Me Videos",
  intro:
    "Brave Me offers dynamic videos and products that lessen the fear of X-rays and MRIs and increase understanding of medical conditions like asthma and diabetes. They are free here or on our YouTube channel @BraveMeRoars. Brave Me\u2019s videos are the exact visual prescription to help patients feel strong, calm and ready for what\u2019s going on!",
  channelUrl: "https://www.youtube.com/@bravemeroars",
  items: [
    {
      id: "asthma",
      label: "Asthma",
      color: "blue",
      title: "I\u2019m Stronger than Asthma!",
      vimeoId: null,
      comingSoon: true,
      badge: "Coming Soon",
      image: "/videos/v-asthma.png",
    },
    {
      id: "diabetes",
      label: "Diabetes",
      color: "orange",
      title: "I\u2019m Stronger than Diabetes!",
      vimeoId: "1135833997",
      image: "/videos/v-diabetes5.png",
    },
    {
      id: "xrays",
      label: "X-rays",
      color: "yellow",
      title: "I\u2019m Ready for My X-ray!",
      vimeoId: "1135827788",
      image: "/videos/v-xrays.png",
    },
    {
      id: "mris",
      label: "MRIs",
      color: "red",
      title: "I\u2019m Ready for My MRI!",
      vimeoId: "1135801892",
      image: "/videos/v-mris.png",
    },
  ],
};

export const futureVideos = {
  title: "Future Brave Me Videos",
  body:
    "More Brave Me videos are in development, with the goal of helping patients understand \u2013 no matter what they are facing medically. Future videos will focus on cancer/leukemia, heart disease, tonsillectomies, food allergies and more. In our quest to empower all patients, we want to help children understand medical diagnoses of a parent, grandparent or friend as well. Brave Me also is excited to release a video to inform children and help them prepare for visiting the dentist.",
  upcoming: [
    "Cancer / Leukemia",
    "Heart disease",
    "Tonsillectomies",
    "Food allergies",
    "Dentist visits",
    "ADHD",
  ],
};

export const values = [
  {
    id: "education",
    title: "Education",
    body:
      "We believe that education is the key to empowering children to face any medical situation with bravery. We need to prepare them for the steps they must go through in as realistic a way as possible. We expect no less as adults when we have to deal with a health issue.",
    color: "blue",
  },
  {
    id: "compassion",
    title: "Compassion",
    body:
      "We believe that engaging our audience starts with compassion, the need to understand and the desire to make things better. There is an emotional aspect to medical procedures and chronic illness that is rarely addressed when communicating with children about their health. We want kids to know that Brave Me understands their fears and will address them in an honest and real way.",
    color: "orange",
  },
  {
    id: "empowerment",
    title: "Empowerment",
    body:
      "Our goal is to empower children to flip the script on health struggles that are frightening. We want to highlight the fact that they are incredibly strong and can handle anything coming their way. We aim to be the spark that ignites the bravery within children to face any medical situation \u2013 either their own or that of a loved one.",
    color: "red",
  },
];

export const scareCTA = {
  title: "Help us take the scare out of medical care",
  body:
    "Brave Me is here to change the medical education landscape for children around the world. All videos are designed to be much more engaging for kids than the basic, clinical videos offered currently online.",
  cta: { label: "Sign up Today", href: "#watch" },
  images: [
    "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjaGVlcmZ1bCUyMGNoaWxkcmVufGVufDB8fHx8MTc4ODg5ODM0N3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1758206523860-0583e7b51a5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxraWRzJTIwaG9zcGl0YWx8ZW58MHx8fHwxNzkxNDMzNDk2fDA&ixlib=rb-4.1.0&q=85",
  ],
};

export const empowerBand = {
  title: "Your kid \u2013 strong, calm and ready for what\u2019s going on!",
  images: [
    "https://images.unsplash.com/photo-1498674202614-ac0172c6c61a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGJyYXZlJTIwY2hpbGR8ZW58MHx8fHwxNzg4ODk4MzQ3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1676313030076-4ac0b37050fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxraWQlMjBkb2N0b3IlMjB2aXNpdHxlbnwwfHx8fDE3ODg4OTgzNDd8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1624272949900-9ae4c56397e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGJyYXZlJTIwY2hpbGR8ZW58MHx8fHwxNzg4ODk4MzQ3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1708687045030-26702e62fc65?auto=format&fit=crop&w=600&q=80",
  ],
};

export const shop = {
  name: "Courage Canyon Outfitters",
  tagline: "Gear up for the adventure. Every purchase boosts a kid\u2019s bravery.",
  bannerImage: "/cco-badge-new.webp",
  products: [
    {
      id: "p2",
      name: "My Friend Riley",
      price: 25,
      color: "orange",
      image: "/products/riley.webp",
    },
    {
      id: "p3",
      name: "Brave Me Cape of Courage",
      price: 22,
      color: "red",
      image: "/products/cape.webp",
    },
    {
      id: "p8",
      name: "Proud Parent Tee",
      price: 22,
      color: "red",
      image: "/products/proud-parent-tee.png",
    },
    {
      id: "meet-greet",
      name: "Brave Me & Riley: Virtual Meet & Greet",
      price: 50,
      color: "orange",
      image: "/products/meet-greet.jpg",
      note: "A 15-min digital meet & greet with Riley \u2013 ask about Brave Me Headquarters and connect with someone whose daily life mirrors yours.",
    },
  ],
};

export const about = {
  founders: [
    {
      name: "Scott Brown",
      role: "Co-Founder",
      image: null,
      bio: "[Placeholder bio] Scott co-founded Brave Me to turn knowledge into courage for kids everywhere. Share your verbiage and I'll drop it right in.",
      color: "blue",
    },
    {
      name: "Andrea Brown",
      role: "Co-Founder",
      image: null,
      bio: "[Placeholder bio] Andrea co-founded Brave Me with a mission to empower every young patient. Share your verbiage and I'll drop it right in.",
      color: "orange",
    },
  ],
  characters: [
    {
      name: "Riley",
      role: "The Brave Pup",
      image: null,
      bio: "[Placeholder] Our beloved dog Riley guides kids on every brave adventure.",
      color: "orange",
    },
    {
      name: "Character Two",
      role: "[Role]",
      image: null,
      bio: "[Placeholder] Add this character's name, photo and story.",
      color: "blue",
    },
    {
      name: "Character Three",
      role: "[Role]",
      image: null,
      bio: "[Placeholder] Add this character's name, photo and story.",
      color: "red",
    },
  ],
};

export const journey = {
  title: "Riley\u2019s Epic Journey",
  intro:
    "[Placeholder] Join Riley on a Homer-like odyssey across three wondrous lands \u2013 gathering knowledge, feelings and courage along the way.",
  lands: [
    {
      id: "mountain",
      name: "Medical Mountain",
      color: "blue",
      image: "/videos/xrays.webp",
      blurb: "[Placeholder] High atop Medical Mountain, Riley learns the facts about procedures and conditions \u2013 knowledge is the first step to bravery.",
    },
    {
      id: "ocean",
      name: "Emotion Ocean",
      color: "orange",
      image: null,
      blurb: "[Placeholder] Across the deep Emotion Ocean, Riley discovers it\u2019s okay to feel scared \u2013 and how to ride every wave of emotion.",
    },
    {
      id: "canyon",
      name: "Courage Canyon",
      color: "red",
      image: "/videos/diabetes.webp",
      blurb: "[Placeholder] At last in Courage Canyon, Riley turns everything learned into unstoppable courage for whatever lies ahead.",
    },
  ],
};

export const socials = [
  { name: "YouTube", href: "https://www.youtube.com/@bravemeroars" },
  { name: "Instagram", href: "https://www.instagram.com/bravemeroars" },
  { name: "Facebook", href: "https://www.facebook.com/bravemeroars" },
  { name: "X", href: "https://x.com/bravemeroars" },
  { name: "TikTok", href: "#" },
];

export const team = {
  riley: {
    name: "Riley",
    tagline: "The star of the show",
    image: "/team/riley-star.jpg",
    doctorImage: "/team/riley-doctor-nurse.webp",
    bio: "Have you ever met a dog and instantly loved him? Riley is our brave pup and the heart of every Brave Me video. In each video, he has to find his way to be prepared for what lies ahead. As much as his Mom and Dad try to get him to not be scared, fear and anxiety creep in and sometimes he is just sick and tired of his health issue. In our medical procedure videos, he learns exactly what to expect and finds his inner courage. In our medical condition videos, he goes on a Homer-like journey visiting some amazing places, but best of all is seeing his friends Captain Conrad and Nano at Brave Me Headquarters.",
    lands: [
      { id: "mountain", name: "Medical Mountain", color: "blue", image: "/team/medical-mountain.webp", blurb: "One of the hardest parts of a chronic illness is knowing the why. Here, Riley watches an old school video and speaks to a doctor and a nurse about what is happening in his lungs with asthma or in his body with diabetes. By learning the facts, he finds out that knowledge is the key to feeling calmer." },
      { id: "ocean", name: "Emotion Ocean", color: "orange", image: "/team/emotion-ocean.webp", blurb: "Emotion Ocean is Riley\u2019s favorite spot, for it is here he learns he is definitely not alone. He feels so different with his diabetes equipment or inhaler, but meeting kids just like him makes his soul feel empowered." },
      { id: "canyon", name: "Courage Canyon", color: "red", image: "/team/courage-canyon.webp", blurb: "Courage Canyon is where Nano shows Riley ways to self-soothe and find positivity when times get tough. He also gets tips from kids who face the exact same daily life." },
    ],
  },
  hq: {
    title: "Brave Me Headquarters",
    image: "/team/hq.jpg",
    blurb: "High in the mountains, Brave Me HQ is where kids can come when they need a bravery boost. With a world of technology and proven methods at their fingertips, they can read his bravery levels and guide him to being strong, calm and ready for what\u2019s going on. Captain Conrad and Nano work with precision to show Riley that his situation may be scary, but with a little help from his friends and family and belief in himself \u2013 he can face anything!",
    characters: [
      { name: "Captain Conrad", role: "", image: "/team/conrad.jpg", bio: "Captain Conrad may present as a stately lion, but he is an expert at making sure that kids who need bravery find their way. His experience at providing courage like rocket fuel is legendary, but he has the heart of a lion and wants to make life better for kids around the world." },
      { name: "Nano", role: "", image: "/team/nano.png", bio: "Robots can get a bad rap, but Nano is pure love and education. She guides Riley on his journey and always knows how to remind Riley that he is loved, strong and more than capable to face his medical journey. Nano knows all, but connects with Riley like his favorite teacher." },
    ],
  },
  crew: [
    { name: "Andrea Brown", role: "CEO \u2013 Chief Empowerment Officer", image: "/team/andrea.jpg" },
    { name: "Scott Brown", role: "CBO \u2013 Chief Bravery Officer", image: "/team/scott.jpg" },
    { name: "James Kemp", role: "Master Puppeteer", image: "/team/james.jpg" },
    { name: "Marnie Dupuis", role: "VP of Publishing", image: "/team/marlene.jpg" },
    { name: "Michelle Rodgers", role: "VP of Operations", image: "/team/michelle.jpg" },
  ],
};

export const kidOfTheWeek = {
  eyebrow: "Shine a Spotlight",
  title: "Brave Me Kid of the Week",
  image: "/kotw/maximus.jpg",
  body: "Every week we celebrate a real-life Health Hero \u2013 a kid whose courage lights up everyone around them. Know a little legend who faces hard things with a big heart? This is your chance to put them in the spotlight. Fill out a few quick details below to nominate the kid you are MOST proud of, and they just might become our next Brave Me Kid of the Week!",
  regions: [
    "Tri-State Area (NY/NJ/CT)",
    "Northeast",
    "Mid-Atlantic",
    "Southeast",
    "Midwest",
    "Great Lakes",
    "South",
    "Southwest",
    "Mountain West",
    "Pacific Northwest",
    "West Coast",
    "Other / International",
  ],
};

export const footer = {
  tagline: "Turning Knowledge into Courage",
  columns: [
    {
      title: "Explore",
      links: ["About", "Our Videos", "Brave Me Kid of the Week", "Courage Canyon Outfitters"],
    },
    {
      title: "Videos",
      links: ["Asthma", "Diabetes", "MRIs", "X-rays"],
    },
    {
      title: "Company",
      links: ["Core Values", "Privacy Policy"],
      contact: { email: "bebrave@braveme.com", phone: "(855) 427-2838" },
    },
  ],
  social: ["Facebook", "Instagram", "YouTube", "Twitter"],
  copyright: "\u00a9 " + new Date().getFullYear() + " Brave Me. All rights reserved.",
};
